import { memo } from 'react';

const TextField = memo(
  ({
    label,
    required,
    error,
    touched,
    helperText,
    className = '',
    fieldClassName = '',
    suffix,
    id,
    name,
    type = 'text',
    ...props
  }) => {
    const hasError = touched && error;
    const inputId = id || name;

    const borderClass = hasError
      ? 'border-error'
      : 'border-merchant-border focus-within:border-merchant-action focus-within:ring-1 focus-within:ring-merchant-action';

    const inputClassName = [
      'w-full cursor-pointer bg-white desktop:text-body text-sm font-medium leading-normal text-merchant-text-primary outline-none placeholder:text-[#c2c6cf] disabled:cursor-not-allowed read-only:cursor-default',
      suffix
        ? 'min-w-0 flex-1 border-0 p-0'
        : [
            'box-border h-10 rounded-field border px-2.5 md:px-3 desktop:h-[50px] desktop:px-4',
            borderClass,
            'focus:border-merchant-action focus:ring-1 focus:ring-merchant-action',
          ].join(' '),
      fieldClassName,
    ].join(' ');

    return (
      <div className={`flex w-full flex-col gap-0.75 desktop:gap-1 ${className}`}>
        {label && (
          <label
            htmlFor={inputId}
            className="desktop:text-[16px] text-sm font-semibold leading-3.75 desktop:leading-5 text-merchant-text-secondary"
          >
            {label}
            {required && <span className="ml-1 text-error">*</span>}
          </label>
        )}

        {suffix ? (
          <div
            className={[
              'box-border flex h-11 w-full items-center gap-1.5 desktop:gap-2 rounded-field border bg-white px-2.5 md:px-3 desktop:h-[50px] desktop:px-4',
              borderClass,
              fieldClassName,
            ].join(' ')}
          >
            <input id={inputId} name={name} type={type} className={inputClassName} {...props} />
            {suffix}
          </div>
        ) : (
          <input id={inputId} name={name} type={type} className={inputClassName} {...props} />
        )}

        {hasError && <p className="desktop:text-[12px] text-[10px] text-error">{error}</p>}
        {!hasError && helperText && (
          <p className="desktop:text-[16px] text-sm text-merchant-text-secondary">{helperText}</p>
        )}
      </div>
    );
  },
);

TextField.displayName = 'TextField';

export default TextField;
